import cardsStyle from '../../styles/components/cards';

const style = () => ({
  clientSessionsCard: {
    ...cardsStyle.card,
  },
  clientSessionsCard__header: {
    ...cardsStyle.card__header,
  },
  clientSessionsCard__title: {
    ...cardsStyle.card__title,
    ...cardsStyle.card__title_primary,
    borderBottom: 'none',
    fontSize: '20px',
    fontWeight: '400',
  },
  clientSessionsCard__content: {
    ...cardsStyle.card__content,
    padding: '0px 20px 5px 20px !important',
  },
});

export default style;
